import * as mobx from 'mobx';
import { MeetingStatus } from '../../../../../api/meetings.dao';
import { IControlMeetingDetailsDTO, MeetingProgress } from '../../../../../api/control.dao';
import { IOperatorDetailsDTO } from '../../../../../api/rooms.dao';

const defaultValues: Partial<IControlMeetingDetailsDTO> = {
    meetingId: null,
    progress: MeetingProgress.STANDBY,
    status: MeetingStatus.Scheduled,
    startDateTime: new Date(),
    endDateTime: new Date(),
    meetingConnectionNotes: '',
    operators: []
};

class ControlFormDataVM {
    @mobx.observable
    public meetingId: number;
    @mobx.observable
    public startDateTime: Date;
    @mobx.observable
    public endDateTime: Date;
    @mobx.observable
    public meetingConnectionNotes: string;
    @mobx.observable
    public operators: IOperatorDetailsDTO[];

    constructor(meetingDetails: Partial<IControlMeetingDetailsDTO> = defaultValues) {
        this.meetingId = meetingDetails.meetingId || defaultValues.meetingId;
        this.startDateTime = meetingDetails.startDateTime || defaultValues.startDateTime;
        this.endDateTime = meetingDetails.endDateTime || defaultValues.endDateTime;
        this.meetingConnectionNotes = meetingDetails.meetingConnectionNotes || defaultValues.meetingConnectionNotes;
        this.operators = meetingDetails.operators || defaultValues.operators;
    }
}

export { ControlFormDataVM };
